import React from 'react';
import './AnalyticsCard.css';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AnalyticsCard = ({
  title,
  value,
  percentage,
  isPositive,
  comparisonPeriod,
  actionButton,
}) => {
  const navigate = useNavigate();

  const handleActionClick = () => {
    if (actionButton?.onClick) {
      actionButton.onClick();
    } else if (actionButton?.route) {
      navigate(actionButton.route);
    }
  };

  return (
    <Box className="analytics-card">
      <Box className="card-header">
        <Typography className="card-title">{title}</Typography>
        {actionButton && (
          <Button
            className="card-action-button"
            onClick={handleActionClick}
            size="small"
            sx={{
              textTransform: 'none',
              fontSize: '12px',
              fontWeight: 500,
              color: '#2563eb',
              padding: '2px 8px',
              minWidth: 'auto',
              '&:hover': {
                backgroundColor: 'rgba(37, 99, 235, 0.08)',
              },
            }}
          >
            {actionButton.label || 'View'}
          </Button>
        )}
      </Box>
      <Typography className="card-value">{value}</Typography>
      {percentage !== null &&
        comparisonPeriod !== null &&
        comparisonPeriod !== '' &&
        comparisonPeriod !== 'lifetime' && (
          <Typography className={`card-percentage ${isPositive ? 'positive' : 'negative'}`}>
            {isPositive ? '↑' : '↓'} {Math.abs(percentage)}% vs {comparisonPeriod}
          </Typography>
        )}
    </Box>
  );
};

export default AnalyticsCard;
